module.exports = __webpack_public_path__ + "static/media/logo-sm-light.b3e8039b.png";